import MenuList from './MenuList.jsx';
import MenuItemCard from './MenuItemCard.jsx';
import MenuItemCardV2 from './MenuItemCardV2.jsx';
import PdpLandingPage from './PdpLandingPage';

export default class MenuLandingPage extends React.Component {
    constructor(props) {
        super(props);
        this.menuListData = this.props.categoriesAndProductData;        
        this.breadcrumbData = this.props.Breadcrumb;
        this.MenuUrl = this.props.menuLandingPage;
        this.MenuTitle = this.props.menuTitle;
        this.menuCardData = this.props.menuCard;
        this.searchMenuText = this.props.menuItems;
        this.disclaimers = this.props.disclaimer;
        this.trademarks = this.props.trademark;
        this.Search = this.Search.bind(this);   

        this.isFullMenuViewActivated = this.props.enableContinuousMenuScroll; // Flag to set continuous menu scroll
        this.sections = {};
        this.menuRef = null;
        this.initialSlug = '';
        this._suppressScrollHandler = false;
        this._unlockTimer = null;
        this.handleScroll = this.handleScroll.bind(this);
        this.scrollMenuRight = this.scrollMenuRight.bind(this);
        this.scrollMenuLeft = this.scrollMenuLeft.bind(this);
        this.handleModalSection = this.handleModalSection.bind(this);
        this.getRecommendationPopup = this.getRecommendationPopup.bind(this);
        this.setHTMLModalData = this.setHTMLModalData.bind(this);
        
       //  this.getComboPage = this.getComboPage.bind(this);
        this.state = {
            allCategories: (this.props.categoriesAndProductData) ? this.props.categoriesAndProductData.Categories : [],
            showModal: false,
            activeCat: null,
            menuItemCurrentData: [],
            isCategoryPage: false,
            autoLinkData: null,
            isMenuItemPage: false,
            isComboPage: false,
            isOnline: true,
            isSearchPage: false,
            searchResult: false,
            filteredList: [],
            recommendationModalHtml: '',
            recommendationShowModal: false
        };
        let isOnline = true;
        if (this.props.categoriesAndProductData != null) {
            isOnline = this.props.categoriesAndProductData.isOnline;
        }
        if (this.props.productDetailData != null) {
            isOnline = this.props.productDetailData.isOnline;
        }
        this.state.isOnline = isOnline;
        this.comboPageData = this.props.productDetailData;
        this.state.isComboPage = this.comboPageData != null;
        this.pushAppbViewItemListToGTMDataLayer = this.pushAppbViewItemListToGTMDataLayer.bind(this);
        this.pushAppbViewItemListToGTMDataLayerV2 = this.pushAppbViewItemListToGTMDataLayerV2.bind(this);
    }
    getComboPage() {
        this.setState({
            isMenuItemPage: false, isCategoryPage: false, isComboPage: true, isSearchPage: false
        });
    }

    updatePathToHash() {
        const currentPath = window.location.pathname; // e.g., "/en/menu/test"
        const pathParts = currentPath.split('/');

        if (pathParts.length == 4) {
            // Remove the last part and use it as the hash
            const hash = pathParts.pop();
            const newPath = pathParts.join('/');
            const newUrl = `${newPath}#${hash}`;

            window.location.replace(newUrl);
        }
    }

    componentDidMount() {
        if (this.isFullMenuViewActivated == true) {
            window.addEventListener("scroll", this.handleScroll);
        }
        if (location) {
            let currentPath = location.pathname;            
            this.setState({
                autoLinkData: currentPath                
            });
            if (currentPath.includes("en/menu-search")) {
                this.setState({
                    isMenuItemPage: false, isCategoryPage: false, isSearchPage: true
                });
            }
            if (currentPath.includes("en/menu/")) {
                if (this.isFullMenuViewActivated == true) {
                    this.updatePathToHash();
                } else {
                    this.getUrlData(currentPath);
                }
                if (!this.state.isComboPage)
                    this.pushAppbViewItemListToGTMDataLayer();
                
            }
            if (currentPath =="/en/menu") {
                this.setState({
                    isMenuItemPage: false, isCategoryPage: true, isSearchPage: false
                });
                if (this.isFullMenuViewActivated == true) {
                    
                    const hash = window.location.hash;
                    history.replaceState(null, null, window.location.pathname);
                    if (hash) {
                        this.initialSlug = hash.replace('#', '');
                        let current = this.initialSlug;
                        this.setState({ activeCat: current }, () => {
                            this.scrollMenuIntoView(current);
                        });
                        const element = document.querySelector(`[data-js-slug="${current}"]`);
                        if (element) {
                            const offset = 160; // sticky header height
                            let top3 = element.getBoundingClientRect().top + window.scrollY - offset;
                            window.scrollTo({ top: top3, behavior: "smooth" });
                        }
                    }
                }
            }
        }
    }
    setHTMLModalData(GREProducts) {
        this.setState({
            recommendationShowModal: true, recommendationModalHtml: GREProducts
        });
        this.displaySScarousel();
        $("#GoogleRecommendationModal").modal('show');
        $('[name = "recommendationPopupTriggered"]').val("1");
    }
    displaySScarousel() {
        let items = document.querySelectorAll('.suggestiveSell .carousel .carousel-item')
        items.forEach((el) => {
            let next = el.nextElementSibling
            var minPerSlide = 3;
            for (var i = 1; i < minPerSlide; i++) {
                if (!next) {
                    // wrap carousel by using first child
                    next = items[0]
                }
                let cloneChild = next.cloneNode(true)
                el.appendChild(cloneChild.children[0])
                next = next.nextElementSibling
            }
        })
    }
    getRecommendationPopup(category) {

        const cookieName = 'RecommendationVisit';
        const isPopupShown = DE.Util.GetCookie(cookieName) === 'true';
        if (isPopupShown) return;
        var Url = '/api/sitecore/Menu2/GetRecommendationPopup';
        let $this = this;
        $.ajax({
            url: Url,
            type: 'POST',
            data: { category },
            success: function (data, status, xhr) {
                if (data.isSuccess) {
                    var GREProducts = data.viewHtml;
                    $this.setHTMLModalData(GREProducts);
                    if (data.recommendedMenuItemsJson) {
                        try {
                            var recommendedMenuItems = JSON.parse(data.recommendedMenuItemsJson);
                            if (Array.isArray(recommendedMenuItems) && recommendedMenuItems.length > 0) {
                                GTMHelper.pushViewItemListToGTMDataLayer("Apps-Recommendations", "2", recommendedMenuItems);
                            }
                        } catch (e) {
                            console.error("Failed to parse recommendedMenuItemsJson:", e);
                        }
                    }
                }                
            },
            error: function (xhr, status, error) {
                console.log('error');
            }
        });
    }
    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
        clearTimeout(this._unlockTimer);
    }
    handleModalSection(slug) {
        this.setState({ showModal: false }, () => {
            this.scrollToSection(slug);
        });

    }
    scrollToSection(slug) {
        const el = this.sections[slug];
        if (!el) return;
        // Lock to avoid handleScroll interfering
        this._suppressScrollHandler = true;
        clearTimeout(this._unlockTimer);
        // Update UI right away
        this.setState({ activeCat: slug }, () => {
            // make sure the clicked tab is visible in menu
            this.scrollMenuIntoView(slug);
        });
        // Scroll the page
        const offset = 160; // sticky header height
        const top = el.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top, behavior: "smooth" });
        // Unlock after scroll
        this._unlockTimer = setTimeout(() => {
            this._suppressScrollHandler = false;
        }, 600); // adjust for smooth scroll duration
        this.pushAppbViewItemListToGTMDataLayerV2(slug);
        this.getRecommendationPopup(slug);
    }
    handleScroll() {
        if (this._suppressScrollHandler) return;
        if (this.initialSlug) {
            let current = this.initialSlug;
            this.setState({ activeCat: current }, () => {
                this.scrollMenuIntoView(current);
            });
            const element = document.querySelector(`[data-js-slug="${current}"]`);
            if (element) {
                const offset = 160; // sticky header height
                let top3 = element.getBoundingClientRect().top + window.scrollY - offset;
                window.scrollTo({ top: top3, behavior: "smooth" });
            }
            setTimeout(() => {
                this.initialSlug = '';
            }, 6000); 
           
        } else {
            const y = window.scrollY;
            const offset = 200;
            let current = '';
            this.state.allCategories.forEach((cat) => {
                const sec = this.sections[cat.CategorySlug];
                if (sec && y >= sec.offsetTop - offset) {
                    current = cat.CategorySlug;
                }
            });
            console.log('handlescroll ', current, this.state.activeCat)
            if (current !== this.state.activeCat) {
                this.setState({ activeCat: current }, () => {
                    this.scrollMenuIntoView(current);
                });
            }
        }
        
    }

    scrollMenuIntoView(category) {
        const menuItems = this.menuRef.querySelectorAll(".scroll-menu-items");
        const activeItem = Array.from(menuItems).find(
            (el) => el.dataset.catslug === category
        );
        if (activeItem) {
            activeItem.scrollIntoView({
                behavior: "smooth",
                inline: "center",
                block: "nearest"
            });
        }
    };
    scrollMenuLeft() {
        if (this.menuRef) {
            this.menuRef.scrollBy({ left: -200, behavior: "smooth" });
        }
    };
    scrollMenuRight() {
        if (this.menuRef) {
            this.menuRef.scrollBy({ left: 200, behavior: "smooth" });
        }
    };

    getUrlData(UrlData) {
        this.setState({
            isMenuItemPage: true, isCategoryPage: false, isSearchPage: false
        });
        if (!this.state.isComboPage) {
            this.state.menuItemCurrentData = this.menuListData.Categories.filter((menuItemData) => {
                return (UrlData === menuItemData.PageUrl)
            });
            if (this.state.menuItemCurrentData.length == 0) {
                history.pushState({}, "Menu", "/en/menu");
            }            
        }
    }

    Search(menuData) {
        var query = $('.menu-search').val();
        if (query.length < 3) {
            this.setState({
                searchResult: false, filteredList: {}
            });
        }
        if (query.length >= 3) {
            this.state.filteredList = [];
            menuData.Categories.map(category => {
                if (category.Name.toUpperCase().indexOf(query.toUpperCase()) > -1) {
                    this.state.filteredList.push(
                        { 'Name': category.Name, 'PageUrl': category.PageUrl }
                    );
                }
                category.MenuItems.map(items => {
                    if (items.Name.toUpperCase().indexOf(query.toUpperCase()) > -1) {
                        this.state.filteredList.push(
                            { 'Name': items.Name, 'PageUrl': items.PageUrl }
                        );
                    }
                })
            });
            console.log(this.state.filteredList);
            if (this.state.filteredList.length != 0) {
                this.setState({
                    searchResult: true
                });
            }
        }
    }


    //GA4 view item list event for standard menu flow
    pushAppbViewItemListToGTMDataLayer() {
        try {
            var index = 0;
            var menuItems = [];
            var listname = this.state.menuItemCurrentData[0].Name;
            var listid = this.state.menuItemCurrentData[0].CategoryId.toString();
            this.state.menuItemCurrentData[0].MenuItems.forEach(item => {
                index++;
                var menuItem = {
                    'item_id': item.ChainProductId.toString(),
                    'item_name': item.Name,
                    'item_brand': 'applebees',
                    'item_category': listname,
                    'item_list_name': listname,
                    'item_list_id': listid,
                    'price': item.Price.trim().replace('$', ''),
                    'quantity': '1',
                    'index': index.toString(),
                }
                menuItems.push(menuItem);
                if (index % 20 == 0 || index == this.state.menuItemCurrentData[0].MenuItems.length) {
                    GTMHelper.pushViewItemListToGTMDataLayer(listname, listid, menuItems);
                    menuItems = [];
                }
            });
        }

        catch (e) {
            console.log(e);
        }
    }
    //GA4 view item list event for new continuous scroll menu flow
    pushAppbViewItemListToGTMDataLayerV2(slug) {
        try {
            let menuItemCurrentData = this.menuListData.Categories.filter((menuItemData) => {
                return (slug === menuItemData.CategorySlug)
            });
            var index = 0;
            var menuItems = [];
            var listname = menuItemCurrentData[0].Name;
            var listid = menuItemCurrentData[0].CategoryId.toString();
            menuItemCurrentData[0].MenuItems.forEach(item => {
                index++;
                var menuItem = {
                    'item_id': item.ChainProductId.toString(),
                    'item_name': item.Name,
                    'item_brand': 'applebees',
                    'item_category': listname,
                    'item_list_name': listname,
                    'item_list_id': listid,
                    'price': item.Price.trim().replace('$', ''),
                    'quantity': '1',
                    'index': index.toString(),
                }
                menuItems.push(menuItem);
                if (index % 20 == 0 || index == menuItemCurrentData[0].MenuItems.length) {                  
                    GTMHelper.pushViewItemListToGTMDataLayer(listname, listid, menuItems);
                    menuItems = [];
                }
            });
        }

        catch (e) {
            console.log(e);
        }
    }
    render() {
        return (
            
            <div className="categories-menu-page">

                {!this.state.isSearchPage && !this.state.isComboPage && this.state.isCategoryPage && this.menuListData.IsDelivery &&
                    <div className="delivery-fee-message">
                        {this.searchMenuText.DeliveryFeeMessage}
                    </div>
                }
                <div className="menu-main-layout">                    
                    {!this.state.isSearchPage &&
                        <div className="">
                            <div className="main-menus-container">
                            {!this.state.isComboPage &&
                                <div className={(this.isFullMenuViewActivated == false) ? "menu-cat-list" : ""}>

                                {/*<!-- Scroll Manu bar starts -->*/}
                                {this.isFullMenuViewActivated == true &&
                                    <div className="scrollableMenuItems" >
                                        <div className="no-padding static-menu-item"  >
                                            <a href="javascript:void(0)" title="Menu Category List" role="link" tabindex="0" onClick={() => this.setState({ showModal: true })}>
                                                <img src="/-/media/applebees2/svg/icons/menuIcon.svg" className="menulistmodal-container" alt="Menu List Icon" />
                                            </a>
                                        </div>
                                        <a href="javascript:void(0)" aria-label="Scroll Categories Left" aria-controls="scrollable-cat-list" aria-hidden="false" className="scrolling-menu-arrows left-arrow" onClick={this.scrollMenuLeft}></a>
                                        <div className="menu-data-scrollable-items" id="scrollable-cat-list" ref={(el) => (this.menuRef = el)}>
                                            {this.menuListData.Categories.map((menuData, i) => (

                                                <span key={i} data-cat={menuData.Name} data-catslug={menuData.CategorySlug} data-categoryid={menuData.CategoryId}
                                                    onClick={() => this.scrollToSection(menuData.CategorySlug)} className={
                                                        this.state.activeCat === menuData.CategorySlug
                                                            ? "scroll-menu-items active "
                                                            : "scroll-menu-items"}>
                                                    {menuData.Name}
                                                </span>

                                            ))}
                                        </div>
                                        <a href="javascript:void(0)" aria-label="Scroll Categories Right" aria-controls="scrollable-cat-list" aria-hidden="false" className="scrolling-menu-arrows right-arrow" onClick={this.scrollMenuRight}></a>
                                    </div>
                                }
                                {/*<!-- Scroll Manu bar ends -->*/}

                                    <div className="cardMenu-listing-wrapper">
                                        {/*display Menu List Items*/}
                                        {this.state.isCategoryPage &&
                                            <div className="cardMenu-listing-section">
                                        <div className={(this.isFullMenuViewActivated == true) ? "container-fluid pdp-menu-full-list" : "container-fluid"}>
                                                    
                                                    <div className="search-bar">
                                                        <div className="row align-items-center">
                                                            <div className="col-12">
                                                    <div className="text-center">
                                                        <a href={this.searchMenuText.SearchMenuLink} className="btn btn-lg btn-text" tabIndex="0">
                                                            <i className="o-icon icon-search"></i> {this.searchMenuText.SearchMenuText}
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/*<a >search menu</a>*/}
                                                    { this.isFullMenuViewActivated == false &&   
                                                        <div className="row align-items-center equal-cols">
                                                        {this.menuListData.Categories.map(menuData => {
                                                            return (
                                                                <MenuList menuCategoriesTitle={menuData.Name}
                                                                    menuCategoriesImage={menuData.Image}
                                                                    menuCategoryUnavailable={menuData.IsUnavailable}
                                                                    cardUrl={menuData.PageUrl} />
                                                            );
                                                        })
                                                        }
                                                        </div>
                                                    }
                                            {this.isFullMenuViewActivated == true &&
                                                <div className="row align-items-center equal-cols">
                                                    {this.menuListData.Categories.map((menuData, i) => {
                                                        return (
                                                            <div key={i} data-js-slug={menuData.CategorySlug} className="p-0"

                                                                ref={(el) => (this.sections[menuData.CategorySlug] = el)}>
                                                                <div className="cat-name h3"> {menuData.Name}</div>
                                                                <p className="p1">{menuData.Description}</p>
                                                                <div className="cardMenu-listing-section sub-Category-Wrapper menuItemV2">
                                                                    <div className="container-fluid">
                                                                        <div className="row align-items-center equal-cols">
                                                                            {menuData.MenuItems.map((item, index) => {
                                                                                return (

                                                                                    <div className="cardMenu-border subcategory-mgpd js-product"
                                                                                        data-productid={item.MenuItemId} data-chainproductid={item.ChainProductId} data-menu-index={index + 1} data-productprice={item.Price}>
                                                                                        <MenuItemCardV2 menuItemTitle={item.Name}
                                                                                            menuItemRestaurantId={MenuLandingPage.restaurantId}
                                                                                            menuItemProductId={item.MenuItemId}
                                                                                            menuItemPrice={item.Price}
                                                                                            menuItemImage={item.Image}
                                                                                            menuItemCalories={item.BaseCalories}
                                                                                            menuItemUrl={item.PageUrl}
                                                                                            menuItemOrderUrl={item.OrderUrl}
                                                                                            menuEnableQuickAdd={item.EnableQuickAdd && (!item.HasModifiers || !item.HasRequiredModifiers)}
                                                                                            sendIsComboPage={this.getComboPage}
                                                                                            menuItemCalcPrice={item.CalcPrice}
                                                                                            menuItemLabels={item.MenuItemLabels}
                                                                                            isFeaturedMenu={item.IsFeaturedItem}
                                                                                            menuItemChainProductId={item.ChainProductId}
                                                                                            isAlcohol={item.IsAlcohol}
                                                                                            menuItemAvailable={item.Availability.Now}
                                                                                            isOnline={this.menuListData.isOnline}
                                                                                            isQuickAdd={menuData.IsQuickAdd}
                                                                                            menuCardData={this.menuCardData}
                                                                                            menuCategory={menuData.Name}
                                                                                        />
                                                                                    </div>
                                                                                )
                                                                            })
                                                                            }

                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        );

                                                    })
                                                    }
                                                </div>

                                            }
                                                </div>
                                            </div>
                                        }
                                        {/*display Menu Subcategory List Items*/}

                                        {this.state.isMenuItemPage &&
                                            <section className="cardMenu-listing-section subCategoryWrapper">
                                                <div className="container-fluid">
                                                    {/*display title & description*/}
                                                    <div className="subCategoryHeader">
                                                        <ul className="p1 breadcrumb">
                                                            <li className="p1 link active-breadcrumb"><a href={this.MenuUrl}>{this.MenuTitle}</a></li>
                                                            <li className="p1">{this.state.menuItemCurrentData[0].Name}</li>
                                                        </ul>
                                                        {<h1 className="js-titleCategory h_1" tabIndex="0" data-categoryid={this.state.menuItemCurrentData[0].CategoryId}>
                                                            <span>{this.state.menuItemCurrentData[0].Name}</span></h1>}
                                                        {<p className="p1 titleDesc" tabIndex="0">
                                                            {this.state.menuItemCurrentData[0].Description}</p>
                                                        }
                                                        {this.menuListData.IsDelivery &&
                                                            <div className="delivery-fee-message">
                                                                {this.searchMenuText.DeliveryFeeMessage}
                                                            </div>
                                                        }
                                                    </div>
                                                    <div className="row align-items-center equal-cols">
                                                    {this.state.menuItemCurrentData[0].MenuItems.map((item, index) => {
                                                            return (

                                                                <div className="cardMenu-border subcategory-mgpd js-product"
                                                                    data-productid={item.MenuItemId} data-chainproductid={item.ChainProductId} data-menu-index={index + 1} data-productprice={item.Price}>
                                                                    <MenuItemCard menuItemTitle={item.Name}
                                                                        menuItemRestaurantId={MenuLandingPage.restaurantId}
                                                                        menuItemProductId={item.MenuItemId}
                                                                        menuItemPrice={item.Price}
                                                                        menuItemImage={item.Image}
                                                                        menuItemCalories={item.BaseCalories}
                                                                        menuItemUrl={item.PageUrl}
                                                                        menuItemOrderUrl={item.OrderUrl}
                                                                        menuEnableQuickAdd={item.EnableQuickAdd && (!item.HasModifiers || !item.HasRequiredModifiers)}
                                                                        sendIsComboPage={this.getComboPage}
                                                                        menuItemCalcPrice={item.CalcPrice}
                                                                        menuItemLabels={item.MenuItemLabels}
                                                                        isFeaturedMenu={item.IsFeaturedItem}
                                                                        menuItemChainProductId={item.ChainProductId}
                                                                        isAlcohol={item.IsAlcohol}
                                                                        menuItemAvailable={item.Availability.Now}
                                                                        isOnline={this.menuListData.isOnline}
                                                                        isQuickAdd={this.state.menuItemCurrentData[0].IsQuickAdd}
                                                                        menuCardData={this.menuCardData}
                                                                        menuCategory={this.state.menuItemCurrentData[0].Name}
                                                                    />
                                                                </div>
                                                            )
                                                        })
                                                        }
                                                        
                                                    </div>
                                                </div>
                                            </section>
                                        }

                                    </div>
                                
                                </div>
                                }
                            {this.state.isComboPage &&
                                <PdpLandingPage data={this.comboPageData} isOnline={this.state.isOnline} breadcrumbData={this.breadcrumbData} disclaimers={this.disclaimers} trademarks={this.trademarks} menuCardData={this.menuCardData} />
                                }

                        </div>
                        < div className="modal fade ageVerifyModal" tabindex="-1" data-bs-backdrop="static" id="ageVerifyModal">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                            <i className="o-icon-sm o-icon--close"></i>
                                        </button>
                                        <h4>{this.menuCardData.AlcoholPopupTitle}</h4>
                                    </div>
                                    <div className="modal-body">
                                        <p>{this.menuCardData.AlcoholPopupBody}</p>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-default  btn-lg btn-md--no-icon js-no" data-bs-dismiss="modal">{this.menuCardData.AlcoholPopupNoButtonText}</button>
                                        <button type="button" className="btn btn-primary btn-lg btn-md--no-icon js-yes" data-bs-dismiss="modal">{this.menuCardData.AlcoholPopupYesButtonText}</button>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="modal fade availablityVerifyModal" tabindex="-1" data-bs-backdrop="static" id="availablityVerifyModal">
                            <div className="modal-dialog">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4>{this.menuCardData.UnavailableItemHeadingText}</h4>
                                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                                            <i className="o-icon-sm o-icon--close"></i>
                                        </button>
                                        
                                    </div>
                                    <div className="modal-body">
                                        <p>{this.menuCardData.UnavailableItemDescriptionText}</p>
                                    </div>
                                    <div className="modal-footer">
                                        <button type="button" className="btn btn-primary   btn-lg btn-md--no-icon js-available-yes" data-bs-dismiss="modal">{this.menuCardData.UnavailableItemContinueText}</button>
                                        <button type="button" className="btn btn-default btn-lg btn-md--no-icon js-available-no" data-bs-dismiss="modal">{this.menuCardData.UnavailableItemCancelText}</button>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        {(this.state.recommendationShowModal == true) && <div className="recommendation-product-container"> <div dangerouslySetInnerHTML={{ __html: this.state.recommendationModalHtml }} /> </div>}

                        </div>
                    }
                    {this.state.isSearchPage &&

                        <section className="pdpSearch-block">
                            <div className="favTabBlock location-container">
                                <div className="row">
                                    <div className="col align-self-center">
                                        {/*<!-- subheader section -->*/}
                                    <div className="sub-header text-center">
                                        <h1 className="h_1 text-uppercase">{this.searchMenuText.SearchMenuHeading}</h1>
                                        </div>
                                        {/*<!-- subheader section -->    */}                                    
                                        <div className="pickup-container">
                                            <div className="search-field-block">
                                                <div className="input-group ">
                                                <input className="menu-search form-control pac-target-input" aria-label="Menu Search"  onChange={(menuListData) => this.Search(this.menuListData ? this.menuListData : null)} placeholder=" " />
                                                    <span className="floating-label p1">Search our menu</span>
                                                <span className="input-group-append js-search-close">
                                                        <i className="o-icon-sm o-icon--search"></i>
                                                    </span>
                                            </div>
                                                {this.state.searchResult &&
                                                    <div className="search">
                                                        <div className="pac-item" >
                                                            {this.state.filteredList.map(searchItem => {
                                                                return (
                                                                    <div className="list-item">
                                                                        <a href={searchItem.PageUrl}>{searchItem.Name}</a>
                                                                    </div>
                                                                )
                                                            })
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>                 
                        </section>
                    }                    
                </div>

                {this.state.showModal &&  this.isFullMenuViewActivated == true   && (
                    <div className="modal show featuredItemsModal" tabindex="-1" id="featuredItemsModal">
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="btn-close" onClick={() => this.setState({ showModal: false })} aria-label="Close">
                                        <i className="o-icon-sm o-icon--close"></i>
                                    </button>
                                    <h4>Listed Category Items</h4>
                                </div>
                                <div className="modal-body">{this.menuListData.Categories.map((menuData, i) => (

                                    <p key={i}>
                                        <a href="javascript:void(0)" onClick={() => this.handleModalSection(menuData.CategorySlug)} className={
                                            this.state.activeCat === menuData.CategorySlug
                                                ? "modal-menu-items active "
                                                : "modal-menu-items"}
                                        >{menuData.Name}</a>
                                    </p>

                                ))}</div>
                                <div className="modal-footer"></div>
                            </div>
                        </div>
                    </div>
                )}
                {this.state.showModal && this.isFullMenuViewActivated == true && (<div className="overlay"></div>)}

            </div>
        );
    }
}
